import { add, startOfDay } from 'date-fns';

export const LEGAL_AGE_DATE = startOfDay(add(new Date(), { years: -18 }));
